import React from 'react'

const LiveSessionScreen = React.lazy(() => import('./index'))

export default function LiveSessionPageWrapperForWebview() {
  return <LiveSessionScreen openedAsWebview={true} withSlug={true} />
}
